import { RefObject, useEffect } from 'react';

const useOutsideAlerter = (
    ref: RefObject<HTMLElement>,
    setIsOpen: (isOpen: boolean) => void,
): void => {
    useEffect(() => {
        function handleClickOutside(event: MouseEvent): void {
            if (
                ref.current &&
                event.target instanceof Node &&
                !ref.current.contains(event.target)
            ) {
                setIsOpen(false);
            }
        }
        document.addEventListener('mousedown', handleClickOutside);
        return (): void => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
        // ref is stable, safe to omit from dependency array
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [setIsOpen]);
};

export default useOutsideAlerter;
